<template>
    <Transition name="modal">
        <div class="modal">
            <div class="modal__overlay">
            </div>
            <div class="modal__wrapper">
                <slot name="content"></slot>
            </div>
        </div>
    </Transition>
</template>

<script>

import {EventBus} from "vue-toastification";

export default {
    name: "modal",
    props: {},
    emits: [],
    components: {},
    mixins: [],
    data() {
        return {}
    },
    methods: {
    },
    computed: {},
    watch: {}
}
</script>
